// extracted by mini-css-extract-plugin
export default {"overlay":"LoadingOverlay_overlay__a8bTF","content":"LoadingOverlay_content__tqQuq","spinner":"LoadingOverlay_spinner__p8-Yq","message":"LoadingOverlay_message__nQAy0"};